import React, { useEffect, useState } from 'react';
import { useMyContext } from '../../../context/MyContext';
import NavBar from '../../../component/b2c/navBar/navBar';
import Sidebar from '../../../component/b2c/sidebar/sidebar';
import { FiDownload } from "react-icons/fi";
import { Base_Url, weightDispute, fetchUser } from '../../../config/config'
import { toast } from 'react-toastify';
import { Upload, X, Eye } from 'lucide-react';
import axios from 'axios';
import Select from "react-dropdown-select";
import Papa from "papaparse";
import { useNavigate } from 'react-router-dom';
import { FileText, CheckCircle } from 'lucide-react';

export default function UploadWeight() {
  const [limit, setLimit] = useState(10);
  const [file, setFile] = useState(null);
  const [Id, setId] = useState('')
  const [isUploading, setIsUploading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const { isDarkMode, isToggleSidebar } = useMyContext();
  const token = localStorage.getItem('token');
  const cus_id = localStorage.getItem('cus_id');
  const navigate = useNavigate()

  useEffect(() => {
    fetchCustomers();
  }, [])

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    setFile(uploadedFile);

    const reader = new FileReader();
    reader.onload = () => {
      const csvText = reader.result;
      Papa.parse(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: (results) => {
          setPreviewData(results.data);
        },
      });
    };
    reader.readAsText(uploadedFile);
  };

  const handleUpload = async (event) => {
    if (!Id) {
      toast.error('Please select a seller first.');
      return;
    }
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    setIsUploading(true);
    if (file) {
      const formData = new FormData();
      formData.append('csv_file', file);
      formData.append('seller_id', Id)
      try {

        const response = await axios.post(Base_Url + "admin/" + weightDispute, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': token,
            'cus_id': cus_id,
          },
        });
        setFile(null);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          setTimeout(() => {
            navigate('/dashboard');
          }, 1000);
          setIsUploading(false);
        } else {
          toast.error("File uploading failed");
          setIsUploading(false);
        }
      } catch (error) {
        toast.error("Error uploading file: " + error.message);
        setIsUploading(false);

      }
    }
  };

  const openPreviewModal = () => {
    setIsPreviewModalOpen(true);
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
  };

  const fetchCustomers = async () => {
    const url = Base_Url + fetchUser;
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          token: token,
          cus_id: cus_id,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      if (data.status === "success") {

        const transformedData = data.data.map(user => {
          const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
          return {
            value: user.id,
            label: `${capitalizedName} (${user.id})`,
          };
        });
        setCustomers(transformedData);
      } else {
        toast.error(`Error: ${data.message} (Code: ${data.code})`);
      }
    } catch (error) {
      toast.error(`Error: ${error.message}`);
    }
  }
  const handleSelectChange = (selected) => {
    if (selected.length > 0) {
      const selectedItem = selected[0];
      setId(selectedItem.value);
    }
  };

  const PreviewModal = () => {
    if (!previewData || previewData.length === 0) return null;

    const headers = Object.keys(previewData[0]);

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
        <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-4xl max-h-[85vh] flex flex-col overflow-hidden border border-gray-200 dark:border-gray-700">

          {/* Header */}
          <div className="flex justify-between items-center px-4 py-2.5 border-b border-gray-200 dark:border-gray-700 bg-gray-800 dark:bg-white shrink-0">
            <div className="flex items-center gap-2">
              <FileText className="w-4 h-4 text-white dark:text-gray-800" />
              <div>
                <h2 className="text-[11px] font-bold text-white dark:text-gray-800 leading-tight">
                  Weight Disputes Preview
                </h2>
                <p className="text-[9px] text-gray-300 dark:text-gray-500">Review your uploaded data</p>
              </div>
            </div>
            <button
              onClick={closePreviewModal}
              className="p-1 rounded-md hover:bg-white/10 dark:hover:bg-black/10 transition-colors text-white dark:text-gray-800"
            >
              <X className="h-4 w-4" />
            </button>
          </div>

          {/* Stats bar */}
          <div className="px-4 py-1.5 border-b border-gray-200 dark:border-gray-700 shrink-0 bg-gray-50 dark:bg-gray-800/30">
            <p className="text-[10px] text-gray-500 dark:text-gray-400">
              Records: <span className="font-semibold text-gray-800 dark:text-white">{previewData.length}</span>
              {' · '}Columns: <span className="font-semibold text-gray-800 dark:text-white">{headers.length}</span>
              {' · '}Showing first 50 rows
            </p>
          </div>

          {/* Table */}
          <div className="flex-1 min-h-0 overflow-auto custom-scrollbar">
            <table className="w-full text-left">
              <thead className="sticky top-0 bg-gray-800 dark:bg-white text-white dark:text-gray-800 text-[9px] uppercase tracking-wider">
                <tr>
                  {headers.map((header, index) => (
                    <th key={index} className="px-3 py-1.5 font-semibold whitespace-nowrap border-r border-white/10 dark:border-gray-200 last:border-r-0">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
                {previewData.slice(0, 50).map((row, rowIndex) => (
                  <tr key={rowIndex} className="hover:bg-gray-50 dark:hover:bg-gray-800/30 transition-colors">
                    {headers.map((header, colIndex) => (
                      <td
                        key={colIndex}
                        className="px-3 py-1.5 text-[10px] text-gray-700 dark:text-gray-300 border-r border-gray-100 dark:border-gray-800 last:border-r-0"
                      >
                        <div className="truncate max-w-[160px]" title={row[header]}>
                          {row[header] || '—'}
                        </div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>

            {previewData.length > 50 && (
              <div className="text-center py-2 text-[10px] text-gray-400 dark:text-gray-500 border-t border-gray-100 dark:border-gray-800">
                Showing first 50 rows of {previewData.length} total rows
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="px-4 py-2 border-t border-gray-200 dark:border-gray-700 flex justify-between items-center shrink-0 bg-gray-50 dark:bg-gray-800/30">
            <div className="flex items-center gap-1.5 text-[10px] text-gray-500 dark:text-gray-400">
              <CheckCircle className="w-3.5 h-3.5 text-green-500" />
              <span>Data loaded successfully</span>
            </div>
            <div className="flex gap-2">
              <button
                onClick={closePreviewModal}
                className="px-3 py-1 text-[10px] font-medium rounded-md border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
              >
                Close
              </button>
              <button
                onClick={handleUpload}
                className="px-3 py-1 text-[10px] font-medium rounded-md bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80 transition-colors flex items-center gap-1.5"
              >
                <Upload className="w-3.5 h-3.5" />
                Proceed
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-black' : 'bg-gray-50'}`}>
      {isPreviewModalOpen && <PreviewModal />}

      <div className="z-10 shrink-0">
        <NavBar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        {isToggleSidebar && (
          <div
            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-white dark:bg-black dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20 border-r border-gray-200 dark:border-gray-800`}
            style={
              window.innerWidth < 768
                ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                : {}
            }
          >
            <Sidebar />
          </div>
        )}

        <div className="flex-1 flex items-center justify-center overflow-hidden bg-gray-200 dark:bg-black p-4">
          <div className="w-full  border border-gray-200 dark:border-gray-700 rounded-xl overflow-hidden bg-white dark:bg-gray-900 shadow-sm">

            {/* Header */}
            <div className="bg-gray-800 dark:bg-white px-4 py-2.5 flex items-center gap-2">
              <Upload className="w-4 h-4 text-white dark:text-gray-800" />
              <div>
                <h2 className="text-[11px] font-bold text-white dark:text-gray-800 leading-tight">
                  Upload Weight Disputes
                </h2>
                <p className="text-[9px] text-gray-300 dark:text-gray-500">Upload a CSV with weight disputes details</p>
              </div>
            </div>

            <div className="p-4 space-y-3.5">
              {/* Customer selection */}
              <div>
                <label htmlFor="Id" className="block text-[9px] font-semibold text-gray-500 dark:text-gray-400 mb-1 uppercase tracking-wider">
                  Select Customer ID
                </label>
                <Select
                  options={customers}
                  onChange={handleSelectChange}
                  className="w-full"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '34px',
                      background: isDarkMode ? '#111827' : '#ffffff',
                      border: '1px solid ' + (isDarkMode ? '#374151' : '#d1d5db'),
                      borderRadius: '8px',
                      fontSize: '11px',
                    }),
                    option: (base, state) => ({
                      ...base,
                      backgroundColor: state.isSelected
                        ? (isDarkMode ? '#ffffff' : '#000000')
                        : state.isFocused
                          ? (isDarkMode ? '#1f2937' : '#f3f4f6')
                          : 'transparent',
                      color: state.isSelected
                        ? (isDarkMode ? '#000000' : '#ffffff')
                        : (isDarkMode ? 'white' : '#111827'),
                      fontSize: '11px',
                    })
                  }}
                />
              </div>

              {/* File upload */}
              <div>
                <label className="block text-[9px] font-semibold text-gray-500 dark:text-gray-400 mb-1 uppercase tracking-wider">
                  Upload CSV File
                </label>

                <div className="relative border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-lg p-4 hover:border-gray-500 dark:hover:border-gray-400 transition-colors cursor-pointer bg-gray-50 dark:bg-gray-800/30">
                  <input
                    type="file"
                    accept=".csv"
                    onChange={handleFileChange}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  />
                  <div className="text-center">
                    <Upload className="w-5 h-5 mx-auto mb-1 text-gray-400 dark:text-gray-500" />
                    <p className="text-[10px] font-medium text-gray-600 dark:text-gray-300">
                      Drop your CSV file here or click to browse
                    </p>
                    <p className="text-[9px] text-gray-400 dark:text-gray-500 mt-0.5">
                      CSV file with weight disputes details
                    </p>

                    {file && (
                      <div className="mt-2 inline-flex items-center gap-1.5 px-2.5 py-1 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800">
                        <CheckCircle className="w-3 h-3 text-green-500" />
                        <span className="text-[10px] font-medium text-gray-700 dark:text-gray-300">{file.name}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action buttons */}
                <div className="flex flex-col sm:flex-row gap-2 mt-3">
                  <button
                    type="button"
                    onClick={handleUpload}
                    disabled={!file || isUploading}
                    className={`flex-1 py-1.5 rounded-md font-medium text-[10px] transition-colors flex items-center justify-center gap-1.5 ${
                      !file || isUploading
                        ? 'bg-gray-100 dark:bg-gray-800 text-gray-400 dark:text-gray-600 cursor-not-allowed'
                        : 'bg-gray-800 dark:bg-white text-white dark:text-gray-800 hover:opacity-80'
                    }`}
                  >
                    {isUploading ? (
                      <div className="w-3 h-3 border-2 border-gray-400 dark:border-gray-500 border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <Upload className="w-3.5 h-3.5" />
                    )}
                    <span>{isUploading ? 'Processing...' : 'Upload & Process'}</span>
                  </button>

                  {file && previewData && (
                    <button
                      type="button"
                      onClick={openPreviewModal}
                      className="flex-1 sm:flex-none sm:px-4 py-1.5 rounded-md font-medium text-[10px] border border-gray-300 dark:border-gray-600 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors flex items-center justify-center gap-1.5"
                    >
                      <Eye className="w-3.5 h-3.5" />
                      <span>Preview</span>
                    </button>
                  )}
                </div>
              </div>

              {/* Template download */}
              <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-3 flex items-center justify-between gap-3 bg-gray-50 dark:bg-gray-800/30">
                <div className="flex items-center gap-2.5 min-w-0">
                  <FileText className="w-4 h-4 text-gray-400 dark:text-gray-500 shrink-0" />
                  <div className="min-w-0">
                    <h3 className="text-[10px] font-semibold text-gray-700 dark:text-gray-300">Need a template?</h3>
                    <p className="text-[9px] text-gray-400 dark:text-gray-500 truncate">Download the Weight Disputes CSV template</p>
                  </div>
                </div>
                <a
                  href="/sampleFile/weight.csv"
                  download="Weight.csv"
                  className="shrink-0 px-3 py-1 bg-gray-800 dark:bg-white text-white dark:text-gray-800 rounded-md font-medium text-[10px] hover:opacity-80 transition-colors flex items-center gap-1.5"
                >
                  <FiDownload className="w-3.5 h-3.5" />
                  <span>Download</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}